// Librerias
import React from 'react'
// Componentes
import Modal from 'react-bootstrap/lib/Modal.js'
// Style
import classNames from 'classnames/bind'
import * as cssModal from './Modal.css'
let cx = classNames.bind(cssModal)

export class ModalTrigger extends React.Component{
    constructor(props){
        super(props)
        this.state = {visible: false}
        let self = this
        this.show = ()=>
            self.setState({visible: true})
        this.hide = ()=>{
            self.setState({visible: false})
        }
    }
    render(){
        return this.props.children(this.state.visible, this.show, this.hide)
    }
}
export class ModalComentario extends React.Component{
    constructor(props){
        super(props)
        this.state = {
            comentario: ''
        }
        this.onComentarioChange = (evt)=>{
            this.setState({comentario: evt.target.value})
        }
        this.submitComentario = ()=>{
            this.props.aceptar(this.state.comentario)
            this.props.hideModal()
        }
    }
    render(){
        return(  
                <Modal show={true} onHide={this.props.hideModal} className={cssModal.modale} dialogClassName={cssModal.modalAumentoDot}>
                    <Modal.Header closeButton>
                        <Modal.Title>Comentario</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="row">
                            <div className="col-sm-12 form-group">
                                <label className="col-sm-2 control-label">Comentario</label>
                                <div className="col-sm-10">
                                    <textarea className="form-control" placeholder="Ingrese Comentario"
                                        value={this.state.comentario} onChange={this.onComentarioChange}
                                    />
                                </div>
                            </div>
                            <div className="col-sm-12 form-group">
                                <button className="btn btn-primary" value={this.state.comentario} onClick={this.submitComentario}>Aceptar</button>
                                <button className="btn btn-cancel" onClick={this.props.hideModal}>Cancelar</button>
                            </div>
                        </div>
                        
                    </Modal.Body>
                </Modal>
        )
    }
}


// WEBPACK FOOTER //
// ./frontEnd/components/shared/Modal.jsx